import { useSelector } from 'react-redux';
import { getCurrentOrg } from 'js/reducers/selectors';
import { Organization } from '@nexla/@types';

export function useCurrentOrg() {
  return useSelector(getCurrentOrg) as Organization;
}

/**
 * Like {@link getCurrentOrg}, but never throws: `getCurrentOrg` dereferences
 * the org entity directly and throws while the current user's org hasn't been
 * normalized into the store yet. Returns `undefined` in that window.
 */
export function selectCurrentOrgSafe(state: unknown): Organization | null | undefined {
  try {
    return getCurrentOrg(state) as Organization | null;
  } catch {
    return undefined;
  }
}
